import React from 'react';

export default function LoadingIcon(props) {
  return props.loading === false ? '' : (
    <div className="p-5 d-flex justify-content-center">
      <div className={`spinner-${props.type ? props.type : 'grow'}`} role="status">
        {/* <span className="sr-only">Ładowanie...</span> */}
      </div>
    </div>
  );
}